export const Duplicate = (props: React.SVGProps<SVGSVGElement>) => {
    return (
      <svg
        {...props}
        width="1em"
        height="1em"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="Duplicate-1--Streamline-Ultimate.svg"
          clipPath="url(#clip0_1_2021)"
        >
          <path
            id="Vector"
            d="M13.8126 5.13542H15.7605C16.1517 5.13542 16.4688 5.45256 16.4688 5.84376V15.7604C16.4688 16.1516 16.1517 16.4688 15.7605 16.4688H5.84383C5.45263 16.4688 5.1355 16.1516 5.1355 15.7604V13.8125"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_2"
            d="M0.53125 1.23958C0.53125 0.848378 0.848385 0.53125 1.23958 0.53125H11.1563C11.5475 0.53125 11.8646 0.848385 11.8646 1.23958V11.1563C11.8646 11.5475 11.5475 11.8646 11.1563 11.8646H1.23958C0.848378 11.8646 0.53125 11.5475 0.53125 11.1563V1.23958Z"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1_2021">
            <rect width="17" height="17" />
          </clipPath>
        </defs>
      </svg>
    );
  };
  